module.exports = __webpack_public_path__ + "static/media/self-awareness.808c8197.svg";